

export const FileExplorerEntry={
    name:"FileExplorerEntry",
    type:"object",
    props:[
        {
            name:"name",
            type:"string",
            description:"File name with extension",
        },
        {
            name:"path",
            type:"string",
            description:"File's absolute path",
        },
        {
            name:"location",
            type:"string",
            description:"File's parent directory absolute path",
        },
        {
            name:"fullpath",
            type:"string",
            description:"File's path property with file:/// as a prefix",
        },
        {name:"lastModified",type:"number"},
        {name:"size",type:"number"},
    ],
}

export default {
    id:"FileExplorer",
    name:"vritra-plugin-fileexplorer",
    description:`
        a cordova plugin for picking and opening local files
        @defines a global <b>FileExplorer</b> object
    `,
    methods:[
        {
            name:"pick",
            type:"(options:object):void",
            props:[{
                name:"options",
                type:"object",
                props:[
                    {
                        name:"multiple",
                        type:"boolean",
                        description:`
                            if true, the user will be able to pick multiple files at once.
                            @default: true
                            @IOS@
                            For ios<14, if multiple is true, the user needs to cancel the picker manually
                            after selecting files.
                        `,
                    },
                    {
                        name:"type",
                        type:"string",
                        description:`
                            The mimeType of pickable files.
                            Use comma-seperated mimeTypes for multiple file types.
                            For mimeTypes lacking the character "/", the string "/*" will be used as a suffix
                            @example:
                            @1) <span>"image"</span> => "image<span>/*</span>"
                            @2) <span>"audio,video"</span> => "audio<span>/*,</span>video<span>/*</span>"
                            @By default the filepicker will show all types of files
                        `,
                        notice:`
                            can't pick images/videos and documents at the same time or request a specific 
                            file extenion on <b>iOS</b>
                            @to pick images/videos all mimetypes should be image/video type,
                            otherwise a document picker is shown
                        `,
                    },
                    {
                        name:"onPick",
                        type:"(value:FileExplorerEntry|FileExplorerEntry[]):void",
                        description:"if multiple is true, entry is an array else an object",
                        props:[FileExplorerEntry],
                    },
                ],
            }],
        },
        {
            name:"useFileType",
            type:"(path:String,callback:function):void",
            description:`
                Gets the mimeType of the path's target file.
                @The path does not need to point to an existing file.
                @It just uses the path file extension to get the corresponding mimeType.
                @example@
                path:".jpeg" => type:"image/jpeg"
            `,
            props:[
                {
                    name:"callback",
                    type:"(type:String):void",
                }
            ],
        },
        {
            name:"open",
            type:"(options:object):void",
            description:"Opens the path's target file in the system default app",
            props:[{
                name:"options",
                type:"object",
                props:[
                    {
                        name:"path",
                        type:"string",
                        description:"path of the file to open",
                    },
                    {name:"onFail",type:"(message:String):void"},
                ],
            }],
        },
        {
            name:"playAudio",
            type:"(options:object):void",
            description:`
                Plays the specified audio file path on background
                @Even if the webview is closed, The audio will keep playing
            `,
            props:[{
                name:"options",
                type:"object",
                props:[
                    {
                        name:"id",
                        type:"string",
                        description:"AudioPlayer id, used to stop audio",
                    },
                    {name:"path",type:"string"},
                    {
                        name:"atRatio",
                        type:"number",
                        description:"A value in 0..1 used to play the audio file at a certain position",
                    },
                    {
                        name:"onPlay",
                        type:"(options:object):void",
                        props:[{
                            name:"options",
                            type:"object",
                            props:[
                                {
                                    name:"duration",
                                    type:"number",
                                    description:"The audio file duration in ms",
                                },
                            ],
                        }],
                    },
                    {name:"onFail",type:"(message:String):void"},
                ],
            }],
        },
        {
            name:"stopAudio",
            type:"(options:object):void",
            props:[{
                name:"options",
                type:"object",
                props:[
                    {
                        name:"id",
                        type:"string",
                        description:"id of the audioPlayer to stop",
                    },
                    {
                        name:"onStop",
                        type:"(options:object):void",
                        props:[{
                            name:"options",
                            type:"object",
                            props:[
                                {
                                    name:"timestamp",
                                    type:"number",
                                    description:"The audio file stop position in ms ",
                                },
                            ],
                        }],
                    },
                ],
            }],
        },
    ],
}
